<template>
  <!-- 月度指标 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">故障报警栏目</span>
    </div>
    <div class="main">
      <div class="headerUnit">
        <span style="width: 60px">报警名称</span>
        <span style="width: 160px">报警内容</span>
        <span style="width: 95px">报警时间</span>
      </div>
      <div class="dataWrapBox" id="dataWarp" @scroll.prevent>
        <div class="dataWrap" id="ulDiv" @scroll.prevent>
          <div
            @scroll.prevent
            class="tableItem"
            v-for="item in dataList"
            :key="item.id"
            :style="{ background: item.index % 2 == 0 ? 'rgba(0,115,255,0.11)' : 'rgba(0,80,186,0.10);' }"
          >
            <span
              v-if="item.malfunctionLevel == '重要'"
              style="width: 60px; text-align: left; text-align: left; color: #f5222d"
              >{{ item.deviceName }}</span
            >
            <span v-else style="width: 60px; text-align: left; text-align: left">{{ item.deviceName }}</span>
            <div style="width: 180px; margin-left: 30px; text-align: left" class="tableItemDiv">
              <a-tooltip>
                <template slot="title">{{ item.malfunctionCause }}</template>
                <span v-if="item.malfunctionLevel == '重要'" style="color: #f5222d">{{ item.malfunctionCause }}</span>
                <span v-else>{{ item.malfunctionCause }}</span>
              </a-tooltip>
            </div>
            <span style="width: 160px; text-align: right" class="tableItemDiv">
              <a-tooltip>
                <template slot="title">{{ item.updateTime }}</template>
                <span v-if="item.malfunctionLevel == '重要'" style="color: #f5222d">{{ item.updateTime }}</span>
                <span v-else>{{ item.updateTime }}</span>
              </a-tooltip>
            </span>
          </div>
        </div>
        <div id="ulDiv2"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import chartResize from '@/mixin/chart-resize'
export default {
  name: 'FaultAlarm',
  components: {},
  data() {
    return {
      speed: 50,
      colee: '',
      colee1: '',
      colee2: '',
      dataList: [],
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      let data = {
        disposeResult: 0,
        sysTab: 1,
        sysType: 4,
      }
      this.$http.get('/pipe-network/water_works_malfunctions/page', { params: data }).then((res) => {
        // this.dataList = data.list.slice(0, 3)
        this.dataList = res.data.list
        console.log(res.data.list, '长度！！！')
        if (this.dataList.length > 3) {
          this.$nextTick(() => {
            console.log('滚动！!!!')
            this.goScroll()
          })
        }
      })
    },
    goScroll() {
      let vm = this
      this.colee2 = document.getElementById('ulDiv2')
      this.colee1 = document.getElementById('ulDiv')
      this.colee = document.getElementById('dataWarp')
      this.colee2.innerHTML = this.colee1.innerHTML // 克隆colee1为colee2

      let MyMar1 = setInterval(this.Marquee1, this.speed) // 设置定时器
      // 鼠标移上时清除定时器达到滚动停止的目的

      this.colee.onmouseover = function () {
        clearInterval(MyMar1)
      }

      this.colee.onmouseout = function () {
        MyMar1 = setInterval(() => {
          vm.Marquee1()
        }, vm.speed)
      }

      this.$once('hook:beforeDestroy', () => {
        clearInterval(MyMar1)
        MyMar1 = null
      })
    },
    Marquee1() {
      // 当滚动至colee1与colee2交界时
      // console.log(this.colee2.offsetTop - this.colee.scrollTop );
      if (this.colee2.offsetTop - this.colee.scrollTop <= 3) {
        this.colee.scrollTop -= this.colee1.offsetHeight // colee跳到最顶端
      } else {
        this.colee.scrollTop++
      }
    },
  },
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 207px;
  width: 600px;
  background: url(~@/assets/myImg/h_10_gzbj.png) no-repeat;
  background-size: contain;
  position: relative;
  .img-title {
    position: absolute;
    position: relative;
    // top: -18px;
    bottom: 18px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }
  .main {
    padding: 0 10px;
    position: absolute;
    top: 30px;
    // float: left;
    height: 200px;
    width: 100%;
    .headerUnit {
      width: 100%;
      height: 30px;
      background-image: linear-gradient(270deg, rgba(7, 42, 80, 0.35) 0%, rgba(84, 169, 255, 0.25) 100%);
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      // text-align: center;

      span {
        text-align: left;
        display: block;
        margin-left: -30px;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 14px;
        color: #10c0ff;
        font-weight: 600;
      }
    }
    .dataWrap,#ulDiv2 {
      // height: 318px;
      width: 100%;
      // padding: 0 10px;
      padding-bottom: 10px;
      // padding-top:20px;
      overflow-x: hidden;
      overflow-y: auto;

      .tableItem {
        height: 40px;
        width: 100%;
        min-height: 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        // text-align: center;
        .tableItemDiv {
          // min-width: 40px;
          // max-width: 60px;
          font-family: MicrosoftYaHeiSemibold;
          font-size: 15px;
          color: #ffffff;
          font-weight: 600;

          span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        span {
          display: inline-block;
          min-width: 40px;
          max-width: 200px;
          font-family: MicrosoftYaHeiSemibold;
          font-size: 15px;
          color: #ffffff;
          font-weight: 600;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
  .dataWrapBox {
    height: 143px;
    width: 100%;
    padding: 0 20px;
    overflow-x: hidden;
    z-index: 100;
    background: rgba(0, 32, 54, 0.75);
    .tableItem {
      width: 368px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // padding: 0 16px;
      // margin-top: 20px;
      .dataItemTitle {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 14px;
        font-weight: 600;
        width: 120px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .dataItemTime {
        font-family: MicrosoftYaHei;
        font-size: 13px;
        color: rgba(9, 9, 9, 0.75);
        text-align: right;
        font-weight: 400;
      }
    }
  }
  .dataWrapBox::-webkit-scrollbar {
    width: 0 !important;
  }
  .dataWrapBox::-webkit-scrollbar {
    -ms-overflow-style: none;
  }
  .dataWrapBox::-webkit-scrollbar {
    overflow: -moz-scrollbars-none;
  }
}
</style>
